import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";

import DownloadForm from "./DownloadForm";

import * as dataActions from "../../utils/data/dataActions";

import { BSModal } from "./";
import classNames from "classnames";
import { toast } from "react-toastify";
import * as downloaderActions from "../../utils/downloader/downloaderActions";
import { downloaderEnums } from "../../utils/downloader/downloaderEnums";

class DownloadButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      showModal: false,
      downloadPath: null,
    };
    this.toastId = null;
    this.close = this.close.bind(this);
    this.download = this.download.bind(this);
    this.downloaded = this.downloaded.bind(this);
    this.open = this.open.bind(this);
    this.submit = this.submit.bind(this);
    this.buildInsurerName = this.buildInsurerName.bind(this);
  }

  componentDidUpdate(){
    if(this.state.downloadPath){
      if(this.props.successDownloads.length > 0){
        let finishedDownloadObj = this.props.successDownloads.find(download => download.path == this.state.downloadPath);
        if(finishedDownloadObj){
          this.downloaded();
        }
      }
      if(this.props.errorDownloads.length > 0){
        let finishedDownloadObj = this.props.errorDownloads.find(download => download.path == this.state.downloadPath);
        if(finishedDownloadObj){
          this.downloaded();
        }
       
      }
    }
  }
  
  close() {
    this.props.setTimeout(() => {
      if (this.props.onClose) {
        this.props.onClose();
      }
      this.setState({ showModal: false });}, 150);
  }

  buildInsurerName(insurerId){
    // may return duplicate insurers; filtering necessary
    
    const uniqueInsurers = this.props.insurers.reduce((acc, insurer) => {
      const included =
        !insurer.insurerId ||
        acc.find(
          (includedInsurer) => includedInsurer.insurerId === insurer.insurerId
        );
      return !included ? [...acc, insurer] : acc;
    }, []);

    let insurerObj = uniqueInsurers.find(insurer => insurer.insurerId == insurerId);

    return insurerObj.insurer.localizations[this.props.locale].name;
  }

  download(values) {
    const {
      model,
      filters,
      alterParameters,
      waitForCookie,
    } = this.props;

    

    let description = this.props.identifier;
    
    if(values){
      if(values.insurerId){
        
        let insurer = this.buildInsurerName(values.insurerId);
        description += ", " + insurer;
      }
      
      if(values.languageCode){
        description+= ": " + values.languageCode; // To identify generated invoices languages.
      }
    }

    let canDownloadInvoiceFlag = true;

    if(this.props.canDownloadInvoice){
      canDownloadInvoiceFlag = this.props.canDownloadInvoice(description);
        /**
         * This is used as a workaround for the invoicesDataTable component.
         * Some data are available in the data table and some are available in the downloadbutton (for identifier),
         * so we need to revalidate if there's a current download. This data comes from the DownloadForm, which is inside the
         * BSModal.
         */
    }

    if(!this.props.disabled && canDownloadInvoiceFlag){
    
    const languageCode = values ? values.languageCode : this.props.locale;

    const headers = { "Accept-Language": languageCode };
    let { path } = this.props;

    if (waitForCookie) {
      path += "&createCookie=true";
    }

    const parameters = (alterParameters &&
      alterParameters(values, { model, path, filters, headers })) || {
      model,
      path,
      filters,
      headers,
    };


    return this.props.dataActions
      .getDataFile(
        parameters.model,
        parameters.path,
        parameters.filters,
        parameters.headers
      )
      .then((result) => {
        if (result.payload.error) {
          this.close();
          throw new SubmissionError({
            _error: result.payload.error.data.error,
          });
        }
        else{
          // If no error while getting the file url
          this.props.downloaderActions.downloadFile(this.props.shortLivedURL, description, undefined, undefined, this.props.showGeneratingToast);
          this.setState({downloadPath: this.props.shortLivedURL});
        }
      });
    }
    else{
      toast(
        <FormattedMessage id="downloader.duplicateDownload" values={{ file: this.props.identifier, br: <br/>}} />,
        {
          type: toast.TYPE.ERROR,
          autoClose: downloaderEnums.AUTO_CLOSE,
        }
      );
    }
  }

  downloaded() {
    this.setState({downloadPath: null});
    
    this.close();
    
    return this.props.dataActions.clearDataFile(this.props.model);
  }

  open(e) {
    e.preventDefault();
    if (this.props.onOpen) {
      this.props.onOpen();
    }
    if (this.props.skipModal) {
      this.download();
    } else {
      this.setState({ showModal: true });
    }
  }

  submit() {
    let form = this.refs.form.getWrappedInstance();
    while (!!form.getWrappedInstance) {
      form = form.getWrappedInstance();
    }
    const submission = form.submit();
    Promise.resolve(submission).then((result) => {
      if (typeof result == "undefined") {
        this.close();
      }
    });
  }

  render() {
    const {
      additionalValidation,
      buttonText,
      customFields,
      icon,
      label,
      title,
      datatableActionButton,
    } = this.props;
    const actionButtonClassNames = classNames({
      "icon icon-in": true,
      invisible: !this.props.visible,
    });
    let style;
    if (!datatableActionButton) {
      style = {
        color: "#1c89b7",
        "text-transform": "uppercase",
        cursor: "pointer",
        "font-family": "icomoon",
      };
    } else {
      null;
    }
    return (
      <span
        className={datatableActionButton ? "dataTable-action-button" : null}
      >
        <span
          ref="action"
          className={
            datatableActionButton
              ? `dataTable-action-button action-icon ${icon}`
              : actionButtonClassNames
          }
          onClick={this.open}
          style={style}
        >
          {label}
        </span>
        <BSModal
          show={this.state.showModal}
          title={title}
          actions={[{ id: 1, text: buttonText, action: this.submit }]}
          onClose={this.close}
        >
          <div>
            <DownloadForm
              scene="modal"
              ref={"form"}
             
              onSubmit={this.download}
              customFields={customFields}
              additionalValidation={additionalValidation}
            />
          </div>
        </BSModal>
      </span>
    );
  }
}

DownloadButton.propTypes = {
  additionalValidation: PropTypes.object,
  alterParameters: PropTypes.func,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  cookieName: PropTypes.string,
  customFields: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  icon: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  model: PropTypes.object.isRequired,
  waitForCookie: PropTypes.bool,
  path: PropTypes.string.isRequired,
  setTimeout: PropTypes.func,
  shortLivedURL: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  datatableActionButton: PropTypes.bool,
  visible: PropTypes.bool,
  languageCode: PropTypes.string,
  locale: PropTypes.string,
  toastMsg: PropTypes.string,
  skipModal: PropTypes.bool,
  closeButton: PropTypes.bool,
  identifier: PropTypes.string,
  successDownloads: PropTypes.array,
  errorDownloads: PropTypes.array,
  insurers: PropTypes.array,
  canDownloadInvoice: PropTypes.func,
  disabled: PropTypes.bool,
  downloaderActions: PropTypes.object,
  showGeneratingToast: PropTypes.bool
};

DownloadButton.defaultProps = {
  buttonText: <FormattedMessage id="common.download" />,
  filters: [],
  icon: "icon-in",
  title: <FormattedMessage id="download.title" />,
  waitForCookie: false,
  datatableActionButton: true,
  visible: true,
  closeButton: true,
};

function mapStateToProps(state, ownProps) {
  const file = state.data[ownProps.model.name].shortLivedURL || {};
  const downloads = state.downloader || {};
  const insurers = state.data.invoiceData || {};

  return {
    shortLivedURL: file.fileUrl || null,
    cookieName: file.cookieName || null,
    locale: state.auth.user.languageCode,
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
    insurers: insurers.items || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions,dispatch)
  };
}

export default ReactTimeout(
  connect(mapStateToProps, mapDispatchToProps)(DownloadButton)
);



// WEBPACK FOOTER //
// ./src/components/common/DownloadButton.js